import { FaBars, FaSearch } from "react-icons/fa";
import "../styles/index.css";
import AnnonceItem from "../components/AnnonceItem";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import PaginationComponent from "pages/Dashboard/components/Paginations";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getAll, setCurrentPage } from "store/slices/agentAnnonceSlice";

const { Row, Col, Button, Spinner, Alert } = require("reactstrap");

function AnnonceListComponent() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const {
        agentAnnonces,
        agentTotalItems,
        agentTotalPages,
        agentCurrentPage,
        agentLoading,
        agentError,
        agentFetchLoading,
    } = useSelector((state) => state.AgentAnnonce);

    const [searchValue, setSearchValue] = useState("");

    const handleSearch = (e) => {
        e.preventDefault();
        console.log("Recherche :", searchValue);
        if (agentCurrentPage === 1) {
            dispatch(
                getAll({
                    page: 1,
                    searchValue: searchValue,
                })
            );
        } else {
            dispatch(setCurrentPage(1));
        }
    };

    useEffect(() => {
        dispatch(
            getAll({
                page: agentCurrentPage,
                searchValue: searchValue,
            })
        ).then(() => { });
    }, [agentCurrentPage]);

    if (agentError) return <Alert color="danger">{agentError.message}</Alert>;
    return (
        <div className="page-title-box" style={{ backgroundColor: "#F3F8F9" }}>
            <Row>
                <Row
                    className="d-flex justify-content-center"
                >
                    <Col
                        md="11"
                        style={{
                            backgroundColor: "#EDF1F2",
                            paddingLeft: 15,
                            paddingRight: 15,
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            height: 50,
                        }}
                    >
                        <Button
                            style={{
                                font: "Poppins",
                                color: "#157088",
                                backgroundColor: "#EDF1F2",
                                fontSize: 16,
                            }}
                            onClick={() => navigate("/myannouncements")}
                        >
                            {t("announcement.myAnnouncements")}
                        </Button>

                        <a
                            href="/annonces/publier"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ font: "Poppins", fontSize: 13 }}
                        >
                            {t("announcement.publishAnnouncement")}
                        </a>
                    </Col>
                </Row>

                {/* search input */}

                <Row className="d-flex justify-content-center mt-3 mb-4">
                    <Col md="5">
                        <form className="app-search d-lg-block" onSubmit={handleSearch}>
                            <div className="position-relative">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Recherchez un club, une annonce ou un essai..."
                                    value={searchValue}
                                    onChange={(e) => setSearchValue(e.target.value)}
                                    style={{
                                        borderRadius: 10,
                                        backgroundColor: "#F3F8F9",
                                        border: "1px solid #0B283980",
                                    }}
                                />
                                <span
                                    onClick={handleSearch}
                                    style={{
                                        position: "absolute",
                                        top: "50%",
                                        right: "10px",
                                        transform: "translateY(-50%)",
                                        display: "flex",
                                        alignItems: "center",
                                        cursor: "pointer",
                                    }}
                                >
                                    <FaSearch size={15} style={{ color: "#0B2839" }} />
                                </span>
                            </div>
                        </form>
                    </Col>
                </Row>
            </Row>
            <Row>
                <div>
                    {agentFetchLoading ? (
                        <div style={{ textAlign: "center", padding: "20px" }}>
                            <Spinner color="primary" />
                        </div>
                    ) : agentAnnonces && agentAnnonces.length > 0 ? (
                        agentAnnonces.map((annonce, key) => (
                            <AnnonceItem annonce={annonce} key={key}></AnnonceItem>
                        ))
                    ) : (
                        <div style={{ marginTop: 20, textAlign: "center" }}>
                            Aucun annonce trouvé.
                        </div>
                    )}
                </div>
                <PaginationComponent
                    totalItems={agentTotalItems}
                    totalPages={agentTotalPages}
                    currentPage={agentCurrentPage}
                    setCurrentPage={setCurrentPage}
                ></PaginationComponent>
            </Row>
        </div>
    )
}

export default AnnonceListComponent